<template>
    <div v-click-outside="closeWhatsApp">
        <transition name="slide">
            <div
                v-show="openModule"
                class="opened"
                :class="serviceType === 'free' ? 'paidOpened' : 'paidOpened'"
            >
                <div v-if="serviceType === 'free'" class="whatsapp-text">
                    <p class="group-title"><strong>Smis<sup>®</sup></strong> Consultants</p>
                    <p>Înscrie-te în grupul nostru dedicat firmelor de consultanță. Este un grup de discuții între profesioniști. Poți cere păreri cu privire la anumite spețe, ne poți oferi feedback cu privire la activitatea Smis® și ești primul care află noutățile și proiectele noastre.</p>
                    <p class="mt-2">Grupul <strong>Smis</strong><sup>®</sup> Consultants este disponibil companiilor cu minim 5 licențe POCSketch® achiziționate.</p>
                    <p class="mt-3"><strong>Vă rugăm să aderați la grup prin următorul link:</strong></p>
                    <div v-if="licensesNumber < 4" id="indisponibil" class="white-button mt-4">Link de acces indisponibil</div>
                    <a v-else href="https://chat.whatsapp.com/LUg3G30kYQYH29E7HgBiG4" target="_blank" class="white-button mt-4">Link de acces</a>
                    <b-tooltip target="indisponibil" triggers="hover" placement="bottom">
                        Disponibil la achiziționarea a 5 licențe <strong>POC</strong>Sketch
                    </b-tooltip>
                </div>
            </div>
        </transition>
        <LicentaM3
            :licentaPopup="modalShow"
            @hideTempModal="modalShow = false"
        ></LicentaM3>
    </div>
</template>


<script>
    import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faChevronUp} from '@fortawesome/free-solid-svg-icons'
    import {faChevronDown} from '@fortawesome/free-solid-svg-icons'
    import {faFacebookMessenger} from '@fortawesome/free-brands-svg-icons'
    import {faWhatsapp} from '@fortawesome/free-brands-svg-icons'
    import Vue from 'vue'
    import LicentaM3 from '@/pages/Aplicatii/M3/M3Sketch/components/LicentaM3'
    import {BTooltip} from 'bootstrap-vue';
    import api from '@/helpers/api'
    import axios from '@/helpers/axios'
    Vue.directive('click-outside', {
        bind: function (el, binding, vnode) {
            el.clickOutsideEvent = function (event) {
                // here I check that click was outside the el and his children
                if (!(el == event.target || el.contains(event.target))) {
                    // and if it did, call method provided in attribute value
                    vnode.context[binding.expression](event);
                }
            };
            document.body.addEventListener('click', el.clickOutsideEvent)
        },
        unbind: function (el) {
            document.body.removeEventListener('click', el.clickOutsideEvent)
        },
    });

    library.add(faChevronUp, faChevronDown, faFacebookMessenger, faWhatsapp)
    export default {
        components: {
            FontAwesomeIcon,
            LicentaM3,
            BTooltip
        },

        props: {
            openModule: null,
            paidCompanies: {
                type: Number,
                default: 0
            },
        },

        data() {
            return {
                opened: false,
                serviceType: 'paid',
                modalShow: false,
                licensesNumber: 0
            }
        },
        watch: {
            data: {
                handler: function () {
                    if (this.data.name) {
                        this.serviceType = 'paid'
                    } else {
                        this.serviceType = 'free'
                    }
                },
            },
        },
        mounted() {
            this.getLicenseData()
            if (this.data) {
                this.serviceType = 'paid'
            } else {
                this.serviceType = 'free'
            }
        },
        methods: {
            getLicenseData() {
                axios.get(api.API_ENDPOINTS.m3Licenses)
                    .then( response => {
                        this.licensesNumber = Number(response.data.m3_licenses_used) + Number(response.data.m3_licenses_available)
                    })
            },
            openConsultant() {
                this.openModule = !this.openModule;
            },
            closeWhatsApp() {
                this.$emit('closeWhatsApp')
            }
        }
    }
</script>

<style scoped>
.b-tooltip >>> .tooltip-inner{
    max-width: 230px;
    padding: 4px 10px;
    text-align: center;
    background: #eef2f9;
    color: #676d86;
    border-radius: 0.25rem;
}
.b-tooltip >>> .arrow:before{
    border-width: 0 0.3rem 0.3rem;
    border-bottom-color: #eef2f9;
}
.whatsapp-text .group-title{
    font-size: 18px !important;
    color: #fff;
    margin-bottom: 15px;
}
.group-title sup{
    font-size: 13px !important;
}
.whatsapp-text p{
    font-size: 13px;
    color: #fff;
    text-indent: 25px;
}
.personal-consultant {
    position: absolute;
    bottom: 0;
    left: 56px;
    width: 100%;
}

.closed {
    padding: 10px 7px;
    height: 100%;
    width: 100%;
    display: flex;
    max-height: 35px;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    transition-delay: 0.2s;
    transition-duration: 0.6s;
    transition-timing-function: ease-in;
}

.close-wide {
}

.closed-preview {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.opened {
    padding: 20px 20px 10px 20px;
    border-radius: 6px;
    height: 100%;
    width: 100%;
    display: flex;
    max-height: 490px;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    position: relative;
    transition: 0.8s;
    min-width: 415px;
}
.white-button{
    font-size: 14px;
    width: 100%;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    border: 1px solid #fff;
    border-radius: 3px;
    transition: 0.3s;
}
.white-button:hover{
    background: #fff;
    color: #03ca8c;
    text-decoration: none;
}
.closed img {
    max-height: 23px;
    object-fit: contain;
}

.closed p, .closed-preview p {
    font-size: 15px;
    font-weight: 700;
    color: #fff;
    margin: 0;
}

.closed svg, .closed-preview svg {
    color: #fff;
}

.free {
    background: linear-gradient(to bottom, #f78a9e, #fe988b);
}

.freeOpened {
    background: linear-gradient(to top, #f78a9e, #fe988b);
    bottom: 0;
}

.paidOpened {
    background: linear-gradient(to bottom, #03ca8c, #02b4da) !important;
    bottom: 0px;
}

.paid {
    background: linear-gradient(to bottom, #03ca8c, #02b4da) !important;
}

.consultant-avatar {
    border-radius: 50%;
    border: 5px solid #fff;
    max-height: 200px;
    margin: 20px 0;
}

.space-between {
    justify-content: space-between;
}

.contact-details {
    width: 100%;
    margin-top: 10px;
}

.contact-details li {
    margin-bottom: 15px;
}

.details p {
    font-size: 13px;
    color: #fff;
    margin: 0;
}

.details .name {
    font-size: 21px;
    font-weight: 700;
}

.icon >>> svg {
    font-size: 40px;
    color: #fff;
}

.no-access {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 100%;
    height: 100%;
    max-height: 80%;
    background: rgba(0, 0, 0, 0.8);
    backdrop-filter: blur(1px);
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 30px;
}

.no-access .title {
    font-size: 15px;
    margin: 10px 0;
    font-weight: 500;
    color: #fff;
}

.no-access p {
    font-size: 11px;
    color: #fff;
    text-align: center;
}

.green-button {
    padding: 6px 20px;
    border-radius: 5px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #161616;
    background: #2ce4c3;
    margin-top: 25px;
    cursor: pointer;
    text-align: center;
    font-weight: 600;
}

.slide-enter-active {
    transition-duration: 0.5s;
    transition-timing-function: ease-in;
}

.slide-leave-active {
    transition-duration: 0.5s;
    transition-timing-function: ease-in;
}

.slide-enter-to, .slide-leave {
    max-height: 490px;
    overflow: hidden;
}

.slide-enter, .slide-leave-to {
    max-height: 0;
    overflow: hidden;
}
</style>